var render = function render(){var _vm=this,_c=_vm._self._c;return _c('confirmation-slip',{attrs:{"manifests":_vm.manifests}})
}
var staticRenderFns = []

export { render, staticRenderFns }